import { Routes } from "@/features/router";
import { Navigate, Route } from "react-router-dom";
import { Gateways } from "./components/gateways/index.react.tsx";
import { Layout } from "./components/layout/Layout.react.tsx";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import config from "@/config/index.ts";

function FlowRoot() {
  return (
    <Route
      path={""}
      element={
        <GoogleReCaptchaProvider reCaptchaKey={config.RECAPTCHA_PUBLIC_KEY}>
          <Layout>
            <Gateways />
          </Layout>
        </GoogleReCaptchaProvider>
      }
    >
      {[
        "",
        Routes.flow + "/",
        Routes.flow_session,
        Routes.flow_block,
        Routes.flow_step,
        Routes.flow_substep
      ].map((route, index) => (
        <Route key={index} path={route} element={<></>} />
      ))}
      <Route path="*" element={<Navigate to={Routes.flow + "/-/welcome"} />} />
      <Route path="" element={<Navigate to={Routes.flow + "/-/welcome"} />} />
    </Route>
  );
}

export default FlowRoot;
